export default function productPrices(state = {}, action) {
  switch (action.type) {
    case 'RECEIVE_PRODUCT_PRICES':
      if (action.payload.currency_code !== state.currencyCode) {
        return {
          ...state,
          currencyCode: action.payload.currency_code,
          currencySymbol: action.payload.currency_symbol,
          products: action.payload.products,
        }
      }

      const products = Object.values(
        [state.products, action.payload.products].reduce((acc, prds) => {
          prds.map(product => (acc[product.id] = product))
          return acc
        }, {}),
      )

      return {
        ...state,
        currencyCode: action.payload.currency_code,
        currencySymbol: action.payload.currency_symbol,
        products: products,
      }

    default:
      return state
  }
}

export function getPriceDetails(productPrices, product) {
  const priceDetails = {
    productId: product.id,
    currencyCode: '',
    currencySymbol: '',
    price: '',
    originalPrice: '',
    traditionalPrice: '',
    bundle: {},
    formattedPrice: '',
    formattedTraditionalPrice: '',
    formattedOriginalPrice: '',
    formattedBasePrice: '',
    formattedDiscountedPrice: '',
  }

  if (productPrices && productPrices.products && productPrices.products.length > 0) {
    const productPrice = productPrices.products.find(prd => prd.id === product.id)

    if (productPrice) {
      const symbol = productPrices.currencySymbol || productPrices.currency_symbol
      const code = productPrices.currencyCode || productPrices.currency_code

      const basePrice = productPrice.original_price
      let discountedPrice = basePrice

      if (productPrice.converted_price) {
        discountedPrice = productPrice.converted_price
      }

      return {
        ...priceDetails,
        currencyCode: code,
        currencySymbol: symbol,
        isDiscounted: productPrice.original_price !== productPrice.converted_price,
        price: productPrice.converted_price,
        originalPrice: productPrice.original_price,
        traditionalPrice: productPrice.traditional_price,
        bundle: productPrice.bundle,
        formattedPrice: `${symbol}${productPrice.converted_price}`,
        formattedTraditionalPrice: `${symbol}${parseInt(productPrice.traditional_price, 10)}`,
        formattedOriginalPrice: `${symbol}${productPrice.original_price}`,
        formattedBasePrice: `${symbol}${basePrice}`,
        formattedDiscountedPrice: `${symbol}${discountedPrice}`,
      }
    }
  }

  return priceDetails
}
